module.exports = __webpack_public_path__ + "img/Invasion-OVCA_10X_OC.25683350.png";